<!-- 调店审核 -->
<template>
  <div class="page">
    <div class="p16">调店审核</div>
    <div class="page-head">
      <div class="mains-content br10">
          <div class="member-header">
              <div class="flex-row">
                <el-select v-model="query.auditStatus" class="select" placeholder="审核状态" filterable>
                  <el-option label="全部状态" value></el-option>
                  <el-option label="待审核" value="wait"></el-option>
                  <el-option label="处理中" value="processing"></el-option>
                  <el-option label="通过" value="pass"></el-option>
                  <el-option label="拒绝" value="refuse"></el-option>
                </el-select>
            </div>
            <el-button type="primary" class="ml10" @click="doData">搜索</el-button>
          </div>
          <div class="plr16" v-perm="{key:'staffTransfer', value:'staffTransfer:list'}">
            <el-table :data="list" :max-height="height - 266" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="applyShopName" label="申请门店" width="280"></el-table-column>
              <el-table-column prop="staffName" label="姓名" width="auto"></el-table-column>
              <!-- <el-table-column prop="transferType" label="调动分类" width="auto">
                <template slot-scope="scope">
                  {{scope.row.transferType == 'formal' ? "他店调入" : "临时帮忙"}}
                </template>
              </el-table-column> -->
              <el-table-column prop="staffTransferTypeCn" label="调动分类" width="auto"></el-table-column>
              <el-table-column prop="transType" label="调动类型" width="auto"></el-table-column>
              <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
              <el-table-column prop="auditTime" label="审核时间" width="auto">
                <template slot-scope="scope">{{ formatDate(scope.row.auditTime) }}</template>
              </el-table-column>
              <el-table-column prop="applyTime" label="申请时间" width="auto">
                <template slot-scope="scope">{{ formatDate(scope.row.applyTime) }}</template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                  <el-link type="primary" @click="orderDetailPage(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
      </div>
    </div>
    <detail-set ref="detailSetForm"  @change="handleChange"></detail-set>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detailSet from "./detail";
export default {
  data() {
    return {
      query: {
        auditStatus: "",
        start: 0,
        size: 20
      },
      url: this.$url.companyStaffTransfer.listForShop,
      list: [],
      height: this.$store.getters.MainHeight,
      options: []
    };
  },
  mixins: [minxin],
  components: { detailSet },
  computed: {},

  created() {
    this.totalCounts();
  },

  methods: {
    back() {
      this.$router.push("/collectMoney");
    },
    orderDetailPage(row) {
      this.$refs["detailSetForm"].$emit("set", row);
    },
    handleChange(bool) {
      if (bool) {
        this.getData();
      }
    },
    totalCounts () {
      this.$api.post(this.$url.companyStaffTransfer.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  background: #fff;
  .member-header {
    padding: 16px;
    display: flex;
    align-items: center;
  }
}
</style>

